<template>
  <div class="page-wrapper">
    <div class="page-title">
      球探报告
    </div>
    <div class="page-main">
      
      <div class="form-box">
        <el-form ref="userFormDom" class="form-dom" :model="userForm" :rules="useRules" label-width="110px">

          <el-form-item label="姓名" prop="userName" class="yioks-form-item">
            <el-input v-model.trim="userForm.userName" class="yioks-input" placeholder="请输入姓名"></el-input>
          </el-form-item>
          
          <el-form-item label="身份证件号" prop="idNumber" class="yioks-form-item">
            <el-input v-model.trim="userForm.idNumber" placeholder="身份证件号" class="yioks-input"></el-input>
          </el-form-item>

          <div class="btn-box">
            <el-button type="primary" @click="handleStart('userFormDom')">开始填写</el-button></el-button>
          </div>
          
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { checkStudentExit } from "@/api/scout";
import { requiredItem, isIdNumber } from "@/assets/js/formRules";
import yioksStorage from '@/assets/js/yioksStorage';

export default {
  data() {
    return {
      userForm: {
        // complete: '',
        userName: "",
        idNumber: "",
      },
      useRules: {
        userName: [requiredItem("姓名")],
        idNumber: [requiredItem("身份证件号"), isIdNumber()],
      },
    };
  },

  methods: {
    handleStart(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const { userName: scout_name, idNumber: scout_id_number } =
            this.userForm;
          const submitParams = {
            scout_name,
            scout_id_number,
          };
          checkStudentExit(submitParams)
            .then(({ data }) => {
              if (data.status !== 0) {
                console.error("data.msg", data.msg);
                this.$message.error(data.msg);
                return;
              }
              const { scout_name, id, scout_id_number, uuid } = data.result;
              yioksStorage.setItem('scoutUuid', uuid)
              yioksStorage.setItem('scoutId', id)
              yioksStorage.setItem('scoutName', scout_name)
              this.$router.push({
                // path: "complete",
                path: "list",
                query: {
                  scoutName: scout_name,
                  scoutId: id,
                  scoutUuid: uuid
                },
              });
            })
            .catch((err) => {
              console.error("err", err);
            });
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
.page-wrapper
  width 100%
  height 710px
  display flex
  margin-top 40px
  justify-content space-between
  align-items center
  flex-direction column
.page-title
  height 60px
  width 890px
  display flex
  box-sizing border-box
  padding-left 20px
  justify-content flex-start
  align-items center
  background-color $block_bg_color_base
  font-size $font_size_big
  color $color_white
.page-main
  height 620px
  width 890px
  display flex
  flex-direction column
  justify-content center
  align-items center
  background-color $block_bg_color_base
  color $color_white
  box-sizing border-box
  padding 25px 25px
.form-dom
  .yioks-form-item
    margin-right 100px
    .yioks-input
      width 300px
  .btn-box
    width 100%
    display flex
    justify-content center
    margin-top 50px
</style>


<style lang="stylus">
.form-dom
  .el-form-item__label
    color #fff !important
    font-size 16px
</style>